import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  CardBody,
  Card
} from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";
import FlashDatePicker from "../../Components/Common/FlashDatePicker";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import OverallWidget from "./OverallWidget";
import TeamMemberPerformance from "./TeamMemberPerformance";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { DISCOUNT, NEWDISCOUNT } from "../../helpers/data_helper";
import DailyDiscountDistribution from "./DailyDiscountDistribution";
import DayOfWeekDiscountPerformance from "./DayofWeekDiscountPerformance";
import DiscountTrends from "../Discount/DiscountTrends";
import DiscountPerformance from "../Discount/DiscountPerformance";
import DiscountDetails from "../Discount/DiscountDetails";


const DiscountNew = () => {
  document.title = "KPI Dashboard | " + process.env.REACT_APP_NAME;
  const [leftCustomDate, setLeftCustomDate] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const handleRefresh = () => {
    setRefresh(!refresh);
  }

  const [mealPeriod, setMealPeriod] = useState("0");
  const [filtermealperiod, setFiltermealperiod] = useState([]);
  const [filterDateList, setFilterDateList] = useState([]);
  const [currency, setCurrency] = useState('$');
  const [selectedMealList, setSelectedMealList] = useState(["all"]);
  const [filterdiscountCodes, setFilterdiscountCodes] = useState([]);
  const [discountCodes, setdiscountCodes] = useState([]);
  const [selectedDiscountCodes, setSelectedDiscountCodes] = useState([]);
  const [serveList, setserveList] = useState([]);
  const [selectedServeList, setSelectedServeList] = useState([]);
  const [filterserveList, setFilterserveList] = useState([]);
  // Data States Of Reciving Data From API


  const changeDiscountCodes = (value) => {
    setSelectedDiscountCodes(value);
    let selVal = [];
    value.map((item) => {
      selVal.push(item.value);
    });
    setdiscountCodes(selVal);
  };

  const changeServerList = (value) => {
    setSelectedServeList(value);
    let selVal = [];
    value.map((item) => {
      selVal.push(item.value);
    });
    setserveList(selVal);
  };

  const changeMealPeriod = (value) => {
    setSelectedMealList(value);
    if (value === "all") {
      setMealPeriod(0);
    } else {
      setMealPeriod(value);
    }
  };
  const {
    filterData,
    filterAjax,
    currentOutlet
  } = useSelector((state) => ({
    filterData: state.Dashboard.filterData,
    filterAjax: state.Dashboard.filterAjax,
    currentOutlet: state.UserOutletGroup.currentOutlet
  }));

  const [leftFilter, setLeftFilter] = useState(
    filterData.flash_date?.find((date) => date.default) || false
  );

  useEffect(() => {
    if (filterData.serverList) {
      setFilterserveList(filterData.serverList);
    }
    if (filterData.mealperiod) {
      setFiltermealperiod(filterData.mealperiod);
    }
    if (filterData.flash_date) {
      setLeftFilter(
        (prev) => prev || filterData.flash_date.find((date) => date.default)
      );
      setFilterDateList(filterData.flash_date);
    }
  }, [filterAjax, filterData]);
  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency);
    }
  }, [currentOutlet]);

  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency)
    }
  }, [currentOutlet]);

  useEffect(() => {
    postDataAPI({
      serviceName: DISCOUNT.serviceName,
      op: DISCOUNT.op_discount_lists,
      leftFilter: leftFilter,
      mealPeriod: mealPeriod,
      page: 0,
      server_id: [],
      discount_id: [],
    }).then((response) => {
      if (response.status === "ok") {
        const discountListArr = [];
        response.data.discount_list.map((item) => {
          discountListArr.push({
            value: item.value,
            label: item.lable
          });
        })
        setFilterdiscountCodes(discountListArr);
      } else {
        console.log(response.data);
      }
    });

  }, [mealPeriod, leftFilter]);

  let date = new Date();
  date.setDate(date.getDate() - 1);

  const getMealString = (selectedMealList) => {
    const match = filtermealperiod.find(item => item.value === selectedMealList);
    return match ? match.label : "All Meal";
  };
  const mealString = getMealString(selectedMealList);

  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Discount Dashboard" pageTitle="Dashboard" activeDate={leftFilter} customDate={leftCustomDate} handleRefresh={handleRefresh} />
          <Card className="p-0 row card-body">
            <CardBody className="mb-1">
              <form className="">
                <Row>
                  <Col className="mb-2 mb-lg-0" sm={12} lg={3}>
                    <FlashDatePicker
                      filterDateList={filterDateList}
                      activeDate={leftFilter}
                      setActiveDate={setLeftFilter}
                      posEnd={false}
                    />
                  </Col>
                  <Col className="mb-2 mb-lg-0" sm={12} lg={3}>
                    <select
                      className="form-select"
                      value={mealPeriod}
                      id="mealPeriod"
                      onChange={(event) => changeMealPeriod(event.target.value)}
                    >
                      <option value="0">All Meal Periods</option>
                      {!filterAjax &&
                        filtermealperiod.length > 0 &&
                        filtermealperiod.map((item) => {
                          return (
                            <option key={item.sp_id} value={item.sp_id}>
                              {item.title +
                                " (" +
                                item.start_time +
                                " To " +
                                item.end_time +
                                ")"}
                            </option>
                          );
                        })}
                    </select>
                  </Col>
                  <Col className="mb-2 mb-lg-0" sm={12} lg={3}>
                    <div>
                      <Select
                        value={selectedDiscountCodes}
                        isMulti={true}
                        onChange={(value) => {
                          changeDiscountCodes(value);
                        }}
                        options={filterdiscountCodes}
                        placeholder="All Discount Codes"
                      />
                    </div>
                  </Col>
                  <Col sm={12} lg={3}>
                    <Select
                      value={selectedServeList}
                      isMulti={true}
                      onChange={(value) => {
                        changeServerList(value);
                      }}
                      options={filterserveList}
                      placeholder="All servers"
                    />
                  </Col>
                </Row>
              </form>
            </CardBody>
          </Card>
          <Row>


            
              <OverallWidget mealPeriod={mealPeriod} leftFilter={leftFilter} discountCodes={discountCodes} serveList={serveList} currency={currency} />
            
            <Col xl={12}>
              <TeamMemberPerformance mealPeriod={mealPeriod} leftFilter={leftFilter} discountCodes={discountCodes} serveList={serveList} currency={currency} />
            </Col>

            <Col xl={12}>
              <DailyDiscountDistribution mealPeriod={mealPeriod} leftFilter={leftFilter} discountCodes={discountCodes} serveList={serveList} currency={currency} />
            </Col>
            <Col xl={12} className='p-0'>
              <DiscountTrends
                mealPeriod={mealPeriod}
                leftFilter={leftFilter}
                discountCodes={discountCodes}
                allDiscountList={filterdiscountCodes}
                serveList={serveList}
                currency={currency}
                changeDiscountCodes={changeDiscountCodes}
              />
            </Col>
            <Col xl={12} className='p-0'>
              <DayOfWeekDiscountPerformance mealPeriod={mealPeriod} leftFilter={leftFilter} discountCodes={discountCodes} serveList={serveList} currency={currency} />
            </Col>
            <Col xl={12} className='p-0'>
              <DiscountPerformance
                mealPeriod={mealPeriod}
                leftFilter={leftFilter}
                discountCodes={discountCodes}
                serveList={serveList}
                currency={currency}
              />
            </Col>
            <Col xl={12} className='p-0'>
              <DiscountDetails
                mealPeriod={mealPeriod}
                leftFilter={leftFilter}
                discountCodes={discountCodes}
                serveList={serveList}
                currency={currency}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DiscountNew;
